export default __webpack_public_path__ + "static/portfolio_gallery_9-5050479681c2cef2d656ca8ac307eec2.jpg";